import { useMemo } from 'react'
import { CircularProgress } from '@/components/commons/circular-progress'
import { Image01Icon } from '@/components/ui/icons'
import { Spinner } from '@/components/ui/spinner'
import { useTranslation } from '@/translations/i18n'

export const ManualRetouchingUploadCard = ({
	totalUploadingImagesCounter,
	uploadedImagesCounter,
	isBulkUploadPhotosPending,
	title,
	subtitle
}: {
	progress: number // todo: remove it if not used
	totalUploadingImagesCounter: number
	uploadedImagesCounter: number
	isBulkUploadPhotosPending: boolean
	title: string
	subtitle: string
}) => {
	const { t } = useTranslation()

	const percentageCompleted = useMemo(
		() =>
			Math.round(
				(uploadedImagesCounter * 100) / totalUploadingImagesCounter
			),
		[uploadedImagesCounter, totalUploadingImagesCounter]
	)

	return (
		<div className='flex w-full items-center justify-between rounded-2xl border border-neutral-200 p-4'>
			<div className='flex gap-2'>
				<Image01Icon className='text-neutral-400' size={16} />
				{isBulkUploadPhotosPending && !uploadedImagesCounter ? (
					<div className='flex flex-col'>
						<h4 className='font-medium text-neutral-700 text-sm'>
							{title}
						</h4>
						<p className='text-neutral-600 text-sm'>{subtitle}</p>
					</div>
				) : (
					<div className='flex flex-col'>
						<h4 className='font-medium text-neutral-700 text-sm'>
							{t('common:upload_total_file', {
								count: totalUploadingImagesCounter
							})}
						</h4>
						<p className='text-neutral-600 text-sm'>
							{t('common:upload_percentage_file', {
								percentage: Number.isNaN(percentageCompleted)
									? 0
									: percentageCompleted
							})}
						</p>
					</div>
				)}
			</div>

			{isBulkUploadPhotosPending && !uploadedImagesCounter ? (
				<Spinner className='fill-primary-600' size={32} />
			) : (
				<CircularProgress
					background='var(--color-primary-200)'
					progress={percentageCompleted}
					size={36}
					strokeColor='var(--color-primary-600)'
				/>
			)}
		</div>
	)
}
